// Taken from https://github.com/angular/angular.js/blob/9f7144b035800c6671a981ba7e5987aeb6c9e959/src/Angular.js#L165-L170
const isIE = window.document.documentMode;

window.addEventListener("DOMContentLoaded", () => {
  if (isIE) {
    document.querySelector("#ie-banner").classList.remove("hidden");
  }
});
